export default __webpack_public_path__ + "static/media/f-01.3b64bd6f.jpg";